module.exports = __webpack_public_path__ + "img/khal_img03.6304c1be.svg";